import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import CategoryListing from './sections/CategoryListing';
import Hero from './sections/Hero';
import Services from './sections/Services';
// import { BrowserRouter } from "react-router-dom";
import ProductCategory from "./sections/ProductCategory";
import ScrollToTopButton from './components/ScrollToTopButton';
import About from './sections/About';
import Contact from './sections/Contact';


function App() {
  return (
    <>
      <Navbar/>
      <Hero/>
      <ScrollToTopButton/>
      <About/>
      <ProductCategory/>
      <Services/>
      <Contact/>
      <Footer/>
    </>
  );
}

export default App;
